export default {
    // Header Section
    "discover_your": "ನಿಮ್ಮ",
    "health_report": "ಆರೋಗ್ಯ ವರದಿಯನ್ನು ಅನ್ವೇಷಿಸಿ",
    "astrological_health_insights": "ಜ್ಯೋತಿಷ್ಯ ಆರೋಗ್ಯ ಒಳನೋಟಗಳು",
    "health_report_description": "ವೈದಿಕ ಜ್ಯೋತಿಷ್ಯದ ಆಧಾರದ ಮೇಲೆ ಸಮಗ್ರ ಆರೋಗ್ಯ ವಿಶ್ಲೇಷಣೆಯನ್ನು ಪಡೆಯಿರಿ. ನಿಮ್ಮ ಆರೋಗ್ಯ ದುರ್ಬಲತೆಗಳು, ರೋಗ ಪ್ರವೃತ್ತಿಗಳು, ತಡೆಗಟ್ಟುವ ಆರೈಕೆ ಕ್ರಮಗಳು ಮತ್ತು ಅತ್ಯುತ್ತಮ ಯೋಗಕ್ಷೇಮಕ್ಕಾಗಿ ವೈಯಕ್ತಿಕ ಕಲ್ಯಾಣ ಶಿಫಾರಸುಗಳನ್ನು ತಿಳಿದುಕೊಳ್ಳಿ.",

    // Service Information
    "enter_details_for_health_analysis": "ಆರೋಗ್ಯ ವಿಶ್ಲೇಷಣೆಗಾಗಿ ನಿಮ್ಮ ವಿವರಗಳನ್ನು ನಮೂದಿಸಿ",
    "complete_health_analysis": "ಸಂಪೂರ್ಣ ಆರೋಗ್ಯ ವಿಶ್ಲೇಷಣೆ",
    "service_price": "ಸೇವೆಯ ಬೆಲೆ",
    "comprehensive_health_analysis_note": "ನಿಮ್ಮ ಆರೋಗ್ಯ ಮಾದರಿಗಳ ಆಳವಾದ ವಿಶ್ಲೇಷಣೆ ಮತ್ತು ವೈಯಕ್ತಿಕ ಕಲ್ಯಾಣ ಮಾರ್ಗದರ್ಶನ",

    // Form Fields
    "full_name": "ಪೂರ್ಣ ಹೆಸರು",
    "enter_full_name": "ನಿಮ್ಮ ಪೂರ್ಣ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
    "name_health_influence": "ನಿಮ್ಮ ಹೆಸರಿನ ಕಂಪನಗಳು ನಿಮ್ಮ ಆರೋಗ್ಯ ಮತ್ತು ಚಿಕಿತ್ಸೆಯ ಮಾದರಿಗಳನ್ನು ಪ್ರಭಾವಿಸುತ್ತವೆ",
    "email_address": "ಇಮೇಲ್ ವಿಳಾಸ",
    "enter_email_address": "ನಿಮ್ಮ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ",
    "phone_number": "ದೂರವಾಣಿ ಸಂಖ್ಯೆ",
    "enter_phone_number": "ನಿಮ್ಮ ದೂರವಾಣಿ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
    "gender": "ಲಿಂಗ",
    "male": "ಪುರುಷ",
    "female": "ಮಹಿಳೆ",
    "other": "ಇತರೆ",
    "date_of_birth": "ಜನ್ಮ ದಿನಾಂಕ",
    "birth_date_health_insights": "ಆರೋಗ್ಯ-ಸಂಬಂಧಿತ ಗ್ರಹ ಸ್ಥಾನಗಳನ್ನು ನಿರ್ಧರಿಸಲು ಅತ್ಯಗತ್ಯ",
    "time_of_birth": "ಜನ್ಮ ಸಮಯ",
    "exact_time_critical_for_health": "ನಿಖರವಾದ ಆರೋಗ್ಯ ಗೃಹ ಲೆಕ್ಕಾಚಾರಗಳಿಗೆ ನಿಖರವಾದ ಸಮಯ ಅಗತ್ಯ",
    "place_of_birth": "ಜನ್ಮ ಸ್ಥಳ",
    "place_of_birth_placeholder": "ನಗರ, ರಾಜ್ಯ, ದೇಶ",
    "location_essential_for_health": "ಸ್ಥಳವು ಆರೋಗ್ಯವನ್ನು ಪ್ರಭಾವಿಸುವ ಗ್ರಹ ಸ್ಥಾನಗಳನ್ನು ಪರಿಣಾಮ ಬೀರುತ್ತದೆ",
    "preferred_language": "ಆದ್ಯತೆಯ ಭಾಷೆ",
    "english": "ಇಂಗ್ಲಿಷ್",
    "hindi": "ಹಿಂದಿ",
    "telugu": "ತೆಲುಗು",
    "kannada": "ಕನ್ನಡ",
    "language_note": "ಆಯ್ಕೆಮಾಡಿದ ಭಾಷೆಯಲ್ಲಿ ನಿಮ್ಮ ಆರೋಗ್ಯ ವಿಶ್ಲೇಷಣೆಯನ್ನು ವಿತರಿಸಲಾಗುವುದು",

    // Core Health Features
    "health_vulnerabilities_analysis": "ಆರೋಗ್ಯ ದುರ್ಬಲತೆಗಳ ವಿಶ್ಲೇಷಣೆ",
    "disease_predisposition_insights": "ರೋಗ ಪ್ರವೃತ್ತಿ ಒಳನೋಟಗಳು",
    "preventive_health_measures": "ತಡೆಗಟ್ಟುವ ಆರೋಗ್ಯ ಕ್ರಮಗಳು",
    "dietary_lifestyle_recommendations": "ಆಹಾರ ಮತ್ತು ಜೀವನಶೈಲಿ ಶಿಫಾರಸುಗಳು",
    "healing_gemstones_remedies": "ಚಿಕಿತ್ಸಾ ರತ್ನಗಳು ಮತ್ತು ಪರಿಹಾರಗಳು",
    "pdf_download": "ಸಮಗ್ರ PDF ವರದಿ",

    "what_you_get": "ನಿಮ್ಮ ಆರೋಗ್ಯ ವಿಶ್ಲೇಷಣೆಯಲ್ಲಿ ಏನು ಸೇರಿದೆ",
    "comprehensive_health_chart": "ಸಮಗ್ರ ಆರೋಗ್ಯ ಚಾರ್ಟ್",
    "body_system_analysis": "ದೇಹ ವ್ಯವಸ್ಥೆ ವಿಶ್ಲೇಷಣೆ",
    "preventive_care_guidance": "ತಡೆಗಟ್ಟುವ ಆರೈಕೆ ಮಾರ್ಗದರ್ಶನ",
    "wellness_enhancement_tips": "ಕಲ್ಯಾಣ ವರ್ಧನೆ ಸಲಹೆಗಳು",

    // Actions & Buttons
    "pay_and_generate_analysis": "ನನ್ನ ಆರೋಗ್ಯ ವಿಶ್ಲೇಷಣೆ ಪಡೆಯಿರಿ",
    "processing_payment": "ಪಾವತಿ ಸಂಸ್ಕರಿಸುತ್ತಿದೆ",
    "processing_request": "ವಿಶ್ಲೇಷಣೆ ರಚಿಸುತ್ತಿದೆ",

    // Payment & Success Messages
    "thank_you": "ಧನ್ಯವಾದಗಳು",
    "payment_successful": "ಪಾವತಿ ಯಶಸ್ವಿಯಾಗಿದೆ!",
    "health_analysis_processing": "ನಿಮ್ಮ ಆರೋಗ್ಯ ವಿಶ್ಲೇಷಣೆಯನ್ನು ನಮ್ಮ ಪರಿಣಿತ ವೈದ್ಯಕೀಯ ಜ್ಯೋತಿಷಿಗಳು ತಯಾರಿಸುತ್ತಿದ್ದಾರೆ. ನಿಮ್ಮ ಆರೋಗ್ಯ ಮಾದರಿಗಳ ಬಗ್ಗೆ ವಿಸ್ತೃತ ಒಳನೋಟಗಳು ಮತ್ತು ವೈಯಕ್ತಿಕ ಕಲ್ಯಾಣ ಮಾರ್ಗದರ್ಶನವನ್ನು ನೀವು ಸ್ವೀಕರಿಸುತ್ತೀರಿ.",
    "order_id": "ಆರ್ಡರ್ ID",
    "payment_id": "ಪಾವತಿ ID",
    "amount_paid": "ಪಾವತಿಸಿದ ಮೊತ್ತ",

    // Delivery Information
    "delivery_information": "ವಿತರಣಾ ಮಾಹಿತಿ",
    "delivery_time": "ವಿಶ್ಲೇಷಣೆ ವಿತರಣೆ",
    "within_12_hours_delivery_note": "ನಿಮ್ಮ ವಿಸ್ತೃತ ಆರೋಗ್ಯ ವರದಿ ೧೨ ಗಂಟೆಗಳೊಳಗೆ ಸಿದ್ಧವಾಗುತ್ತದೆ",
    "whatsapp_notification": "WhatsApp ಅಪ್‌ಡೇಟ್‌ಗಳು",
    "whatsapp_delivery_note": "WhatsApp ನಲ್ಲಿ ತಕ್ಷಣ ಅಧಿಸೂಚನೆಗಳನ್ನು ಸ್ವೀಕರಿಸಿ",
    "email_delivery": "ಇಮೇಲ್ ವಿತರಣೆ",
    "email_delivery_note": "ಸಂಪೂರ್ಣ ವಿಶ್ಲೇಷಣೆಯನ್ನು ವಿತರಿಸಲಾಗಿದೆ",

    // What You'll Receive
    "what_youll_receive": "ನಿಮ್ಮ ಆರೋಗ್ಯ ವಿಶ್ಲೇಷಣೆ ಪ್ಯಾಕೇಜ್",
    "detailed_health_report": "ಸಮಗ್ರ ಆರೋಗ್ಯ ವರದಿ (PDF)",
    "body_system_vulnerability_analysis": "ದೇಹ ವ್ಯವಸ್ಥೆ ದುರ್ಬಲತೆ ವಿಶ್ಲೇಷಣೆ",
    "preventive_healthcare_plan": "ತಡೆಗಟ್ಟುವ ಆರೋಗ್ಯ ಯೋಜನೆ",
    "dietary_wellness_guidelines": "ಆಹಾರ ಮತ್ತು ಕಲ್ಯಾಣ ಮಾರ್ಗಸೂಚಿಗಳು",
    "healing_remedies_recommendations": "ಚಿಕಿತ್ಸಾ ಪರಿಹಾರಗಳು ಮತ್ತು ಶಿಫಾರಸುಗಳು",

    // Visual Content
    "sample_health_analysis": "ಮಾದರಿ ಆರೋಗ್ಯ ವಿಶ್ಲೇಷಣೆ",
    "health_strength_indicator": "ಆರೋಗ್ಯ ಶಕ್ತಿ ಸೂಚಕ",
    "sample_health_reading": "ಹೃದಯರಕ್ತನಾಳದ ಕಲ್ಯಾಣದ ಮೇಲೆ ಗಮನ ಹೊಂದಿದ ಬಲವಾದ ಜೀವಶಕ್ತಿ",
    "sample_health_preview": "ವ್ಯವಸ್ಥೆಯ ಒಳನೋಟಗಳೊಂದಿಗೆ ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಆರೋಗ್ಯ ವಿಶ್ಲೇಷಣೆಯ ಪೂರ್ವವೀಕ್ಷಣೆ",
    "health_categories": "ಆರೋಗ್ಯ ವರ್ಗಗಳು",

    // Health System Types
    "cardiovascular": "ಹೃದಯರಕ್ತನಾಳ",
    "neurological": "ನರವೈಜ್ಞಾನಿಕ",
    "respiratory": "ಉಸಿರಾಟ",
    "digestive": "ಜೀರ್ಣಾಂಗ",
    "skeletal": "ಅಸ್ಥಿಪಂಜರ",
    "immune_system": "ರೋಗನಿರೋಧಕ ವ್ಯವಸ್ಥೆ",

    // Status & Processing
    "your_health_analysis_status": "ನಿಮ್ಮ ಆರೋಗ್ಯ ವಿಶ್ಲೇಷಣೆ ಸ್ಥಿತಿ",
    "processing_your_analysis": "ನಿಮ್ಮ ಆರೋಗ್ಯ ಮಾದರಿಗಳನ್ನು ವಿಶ್ಲೇಷಿಸುತ್ತಿದೆ",
    "analysis_processing_message": "ನಮ್ಮ ವೈದ್ಯಕೀಯ ಜ್ಯೋತಿಷ್ಯ ಪರಿಣಿತರು ನಿಮ್ಮ ಆರೋಗ್ಯ ದುರ್ಬಲತೆಗಳು ಮತ್ತು ಕಲ್ಯಾಣ ಶಿಫಾರಸುಗಳನ್ನು ನಿರ್ಧರಿಸಲು ನಿಮ್ಮ ಗ್ರಹ ಸ್ಥಾನಗಳನ್ನು ಅಧ್ಯಯನ ಮಾಡುತ್ತಿದ್ದಾರೆ.",
    "request_id": "ವಿಶ್ಲೇಷಣೆ ID",
    "status": "ಸ್ಥಿತಿ",
    "processing": "ಪ್ರಗತಿಯಲ್ಲಿದೆ",
    "pending": "ಸರದಿಯಲ್ಲಿದೆ",
    "email_notification_sent": "ದೃಢೀಕರಣ ಇಮೇಲ್ ಕಳುಹಿಸಲಾಗಿದೆ",
    "whatsapp_update_coming": "WhatsApp ಅಪ್‌ಡೇಟ್‌ಗಳು ಸಕ್ರಿಯಗೊಳಿಸಲಾಗಿದೆ",
    "delivery_within_12_hours": "ವರದಿ ೧೨ ಗಂಟೆಗಳೊಳಗೆ ಸಿದ್ಧ",

    // Support & Contact
    "contact_support": "ಆರೋಗ್ಯ ಬೆಂಬಲವನ್ನು ಸಂಪರ್ಕಿಸಿ",
    "need_help": "ಮಾರ್ಗದರ್ಶನ ಬೇಕೇ?",
    "contact_us_at": "ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ",

    // Error Messages
    "please_fill_all_required_fields": "ದಯವಿಟ್ಟು ಎಲ್ಲಾ ಅಗತ್ಯ ಜನ್ಮ ವಿವರಗಳನ್ನು ಪೂರ್ಣಗೊಳಿಸಿ",
    "payment_failed": "ಪಾವತಿ ಯಶಸ್ವಿಯಾಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    "processing_failed": "ವಿಶ್ಲೇಷಣೆ ಸಂಸ್ಕರಣೆ ವಿಫಲವಾಗಿದೆ. ನಮ್ಮ ಬೆಂಬಲ ತಂಡವನ್ನು ಸಂಪರ್ಕಿಸಿ.",

    // Health-Specific Elements
    "sixth_house": "೬ನೇ ಗೃಹ (ಆರೋಗ್ಯ ಗೃಹ)",
    "eighth_house": "೮ನೇ ಗೃಹ (ದೀರ್ಘಕಾಲೀನ ಆರೋಗ್ಯ)",
    "twelfth_house": "೧೨ನೇ ಗೃಹ (ಆಸ್ಪತ್ರೆಗೆ ದಾಖಲು)",
    "ascendant_health": "ಲಗ್ನ ಮತ್ತು ಒಟ್ಟಾರೆ ಜೀವಶಕ್ತಿ",
    "moon_health": "ಚಂದ್ರ ಮತ್ತು ಮಾನಸಿಕ ಆರೋಗ್ಯ",
    "mars_energy": "ಮಂಗಳ ಮತ್ತು ದೈಹಿಕ ಶಕ್ತಿ",

    // Body Systems Analysis
    "circulatory_system": "ರಕ್ತಪರಿಚಲನಾ ವ್ಯವಸ್ಥೆ",
    "nervous_system": "ನರಮಂಡಲ",
    "respiratory_system": "ಉಸಿರಾಟದ ವ್ಯವಸ್ಥೆ",
    "digestive_system": "ಜೀರ್ಣಾಂಗ ವ್ಯವಸ್ಥೆ",
    "musculoskeletal_system": "ಸ್ನಾಯು-ಅಸ್ಥಿಪಂಜರ ವ್ಯವಸ್ಥೆ",
    "endocrine_system": "ಅಂತಃಸ್ರಾವಕ ವ್ಯವಸ್ಥೆ",
    "reproductive_system": "ಸಂತಾನೋತ್ಪತ್ತಿ ವ್ಯವಸ್ಥೆ",
    "excretory_system": "ವಿಸರ್ಜನಾ ವ್ಯವಸ್ಥೆ",

    // Health Vulnerabilities
    "genetic_predispositions": "ಆನುವಂಶಿಕ ಪ್ರವೃತ್ತಿಗಳು",
    "chronic_condition_risks": "ದೀರ್ಘಕಾಲೀನ ಸ್ಥಿತಿ ಅಪಾಯಗಳು",
    "acute_illness_patterns": "ತೀವ್ರ ಅನಾರೋಗ್ಯ ಮಾದರಿಗಳು",
    "mental_health_factors": "ಮಾನಸಿಕ ಆರೋಗ್ಯ ಅಂಶಗಳು",
    "stress_vulnerability": "ಒತ್ತಡ ದುರ್ಬಲತೆ ಕ್ಷೇತ್ರಗಳು",
    "injury_prone_areas": "ಗಾಯಕ್ಕೆ ಒಳಗಾಗುವ ಕ್ಷೇತ್ರಗಳು",

    // Preventive Measures
    "early_warning_signs": "ಆರಂಭಿಕ ಎಚ್ಚರಿಕೆ ಚಿಹ್ನೆಗಳು",
    "regular_checkup_schedule": "ನಿಯಮಿತ ತಪಾಸಣೆ ವೇಳಾಪಟ್ಟಿ",
    "screening_recommendations": "ಆರೋಗ್ಯ ತಪಾಸಣೆ ಶಿಫಾರಸುಗಳು",
    "vaccination_guidance": "ಲಸಿಕೆ ಮಾರ್ಗದರ್ಶನ",
    "lifestyle_modifications": "ಜೀವನಶೈಲಿ ಮಾರ್ಪಾಡುಗಳು",
    "exercise_prescriptions": "ವ್ಯಾಯಾಮ ಸೂಚನೆಗಳು",

    // Dietary Recommendations
    "constitutional_diet": "ಸಾಂವಿಧಾನಿಕ ಆಹಾರ ಯೋಜನೆ",
    "foods_to_include": "ಸೇರಿಸಬೇಕಾದ ಆಹಾರಗಳು",
    "foods_to_avoid": "ತಪ್ಪಿಸಬೇಕಾದ ಆಹಾರಗಳು",
    "meal_timing": "ಅತ್ಯುತ್ತಮ ಊಟದ ಸಮಯ",
    "seasonal_adjustments": "ಋತುಮಾನದ ಆಹಾರ ಹೊಂದಾಣಿಕೆಗಳು",
    "supplementation_needs": "ಪೂರಕ ಅಗತ್ಯತೆಗಳು",

    // Lifestyle Guidance
    "sleep_patterns": "ಅತ್ಯುತ್ತಮ ನಿದ್ರೆಯ ಮಾದರಿಗಳು",
    "exercise_routine": "ಶಿಫಾರಸು ಮಾಡಿದ ವ್ಯಾಯಾಮ ದಿನಚರಿ",
    "stress_management": "ಒತ್ತಡ ನಿರ್ವಹಣೆ ತಂತ್ರಗಳು",
    "work_life_balance": "ಕೆಲಸ-ಜೀವನ ಸಮತೋಲನ",
    "environmental_factors": "ಪರಿಸರ ಆರೋಗ್ಯ ಅಂಶಗಳು",
    "social_health": "ಸಾಮಾಜಿಕ ಮತ್ತು ಭಾವನಾತ್ಮಕ ಆರೋಗ್ಯ",

    // Healing & Remedies
    "ayurvedic_remedies": "ಆಯುರ್ವೇದಿಕ ಪರಿಹಾರಗಳು",
    "herbal_recommendations": "ಗಿಡಮೂಲಿಕೆ ಶಿಫಾರಸುಗಳು",
    "gemstone_therapy": "ರತ್ನ ಚಿಕಿತ್ಸೆ",
    "color_therapy": "ಬಣ್ಣ ಚಿಕಿತ್ಸೆ",
    "sound_healing": "ಧ್ವನಿ ಚಿಕಿತ್ಸೆ",
    "yoga_practices": "ಚಿಕಿತ್ಸಾತ್ಮಕ ಯೋಗ ಅಭ್ಯಾಸಗಳು",
    "meditation_techniques": "ಚಿಕಿತ್ಸಾ ಧ್ಯಾನ ತಂತ್ರಗಳು",
    "breathing_exercises": "ಪ್ರಾಣಾಯಾಮ ಮತ್ತು ಉಸಿರಾಟದ ವ್ಯಾಯಾಮಗಳು",

    // Mental Health
    "psychological_patterns": "ಮಾನಸಿಕ ಮಾದರಿಗಳು",
    "emotional_balance": "ಭಾವನಾತ್ಮಕ ಸಮತೋಲನ",
    "mental_clarity": "ಮಾನಸಿಕ ಸ್ಪಷ್ಟತೆ ವರ್ಧನೆ",
    "memory_concentration": "ಸ್ಮರಣೆ ಮತ್ತು ಏಕಾಗ್ರತೆ",
    "anxiety_management": "ಆತಂಕ ನಿರ್ವಹಣೆ",
    "depression_prevention": "ಖಿನ್ನತೆ ತಡೆಗಟ್ಟುವಿಕೆ",

    // Timing & Cycles
    "health_cycles": "ವೈಯಕ್ತಿಕ ಆರೋಗ್ಯ ಚಕ್ರಗಳು",
    "vulnerable_periods": "ಆರೋಗ್ಯ ದುರ್ಬಲ ಅವಧಿಗಳು",
    "recovery_periods": "ನೈಸರ್ಗಿಕ ಚೇತರಿಕೆ ಅವಧಿಗಳು",
    "optimal_treatment_timing": "ಅತ್ಯುತ್ತಮ ಚಿಕಿತ್ಸೆ ಸಮಯ",
    "surgery_timing": "ಶಸ್ತ್ರಚಿಕಿತ್ಸಾ ಕಾರ್ಯವಿಧಾನ ಸಮಯ",
    "detox_periods": "ವಿಷಶುದ್ಧೀಕರಣ ಅವಧಿಗಳು",

    // Age-Related Health
    "childhood_health": "ಬಾಲ್ಯದ ಆರೋಗ್ಯ ಮಾದರಿಗಳು",
    "adolescent_health": "ಹದಿಹರೆಯದ ಆರೋಗ್ಯ ಸಮಸ್ಯೆಗಳು",
    "adult_health": "ವಯಸ್ಕ ಆರೋಗ್ಯ ನಿರ್ವಹಣೆ",
    "middle_age_concerns": "ಮಧ್ಯವಯಸ್ಸಿನ ಆರೋಗ್ಯ ಕಾಳಜಿಗಳು",
    "senior_health": "ಹಿರಿಯ ಆರೋಗ್ಯ ಮಾರ್ಗದರ್ಶನ",
    "longevity_factors": "ದೀರ್ಘಾಯುಷ್ಯ ಅಂಶಗಳು",

    // Women's Health
    "menstrual_health": "ಋತುಚಕ್ರ ಆರೋಗ್ಯ",
    "fertility_factors": "ಫಲವತ್ತತೆ ಅಂಶಗಳು",
    "pregnancy_guidance": "ಗರ್ಭಾವಸ್ಥೆಯ ಆರೋಗ್ಯ ಮಾರ್ಗದರ್ಶನ",
    "menopause_management": "ಋತುಬಂಧ ನಿರ್ವಹಣೆ",
    "hormonal_balance": "ಹಾರ್ಮೋನುಗಳ ಸಮತೋಲನ",

    // Men's Health
    "vitality_enhancement": "ಜೀವಶಕ್ತಿ ವರ್ಧನೆ",
    "prostate_health": "ಪ್ರಾಸ್ಟೇಟ್ ಆರೋಗ್ಯ",
    "testosterone_balance": "ಟೆಸ್ಟೋಸ್ಟೆರಾನ್ ಸಮತೋಲನ",
    "cardiovascular_focus": "ಹೃದಯರಕ್ತನಾಳದ ಗಮನ",
    "stress_related_issues": "ಒತ್ತಡ-ಸಂಬಂಧಿತ ಸಮಸ್ಯೆಗಳು",

    // Specialty Areas
    "skin_health": "ಚರ್ಮ ಮತ್ತು ಸೌಂದರ್ಯ ಆರೋಗ್ಯ",
    "eye_health": "ಕಣ್ಣಿನ ಆರೋಗ್ಯ",
    "dental_health": "ದಂತ ಆರೋಗ್ಯ",
    "hair_health": "ಕೂದಲಿನ ಆರೋಗ್ಯ",
    "joint_health": "ಕೀಲುಗಳ ಆರೋಗ್ಯ",
    "metabolic_health": "ಚಯಾಪಚಯ ಆರೋಗ್ಯ",

    // Emergency Preparedness
    "health_emergencies": "ಆರೋಗ್ಯ ತುರ್ತು ಪರಿಸ್ಥಿತಿ ಸಿದ್ಧತೆ",
    "first_aid_guidance": "ಪ್ರಾಥಮಿಕ ಚಿಕಿತ್ಸೆ ಮಾರ್ಗದರ್ಶನ",
    "emergency_contacts": "ತುರ್ತು ಆರೋಗ್ಯ ಸಂಪರ್ಕಗಳು",
    "medication_management": "ಔಷಧ ನಿರ್ವಹಣೆ",
    "allergy_alerts": "ಅಲರ್ಜಿ ಎಚ್ಚರಿಕೆಗಳು",

    // Holistic Wellness
    "mind_body_connection": "ಮನ-ದೇಹ ಸಂಪರ್ಕ",
    "spiritual_healing": "ಆಧ್ಯಾತ್ಮಿಕ ಚಿಕಿತ್ಸಾ ಅಭ್ಯಾಸಗಳು",
    "energy_healing": "ಶಕ್ತಿ ಚಿಕಿತ್ಸಾ ವಿಧಾನಗಳು",
    "chakra_balancing": "ಚಕ್ರ ಸಮತೋಲನ",
    "aura_cleansing": "ಆರಾ ಶುದ್ಧೀಕರಣ",
    "holistic_integration": "ಸಮಗ್ರ ಆರೋಗ್ಯ ಸಂಯೋಜನೆ"
};
